import Vue from 'vue'
import App from './App.vue'
import router from './router'
import eventEmitter from '@/plugins/eventEmitter.js'
import log from '@/plugins/log.js'

// 引入自定义事件
Vue.use(eventEmitter)

// 打点
Vue.use(log)

const FastClick = require('@em/fastclick')
FastClick.attach(document.body)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
